import React, { useState, useEffect } from 'react'

const DonationHistory = () => {
    const [donationHistory, setDonationHistory] = useState([]);
    const [loading, setLoading] = useState(true);

    // Fetch donation details from backend
    useEffect(() => {
        const fetchDonationHistory = async () => {
            try {
                // Replace with your actual backend API endpoint
                const response = await fetch('https://apis.anvifoundation.com/anvi/donation-history');

                // Check if the response is ok
                if (!response.ok) {
                    throw new Error('Failed to fetch donation history');
                }

                // Parse the JSON response
                const data = await response.json();

                // Set the donation history data
                setDonationHistory(data);
                setLoading(false);
            } catch (error) {
                console.error('Error fetching donation history:', error);
                setLoading(false);
            }
        };

        // Call the fetch function when the component mounts
        fetchDonationHistory();
    }, []);


    const formatDate = (dateString) => {
       const date = new Date(dateString);
        return date.toLocaleDateString();
    };


    return (
        <>
            <section className='my-5'>
                <div className='container'>

                    <p className='sec-heading'>Donation History</p>
                    <hr className='sec-heading-hr my-0' />

                    <div className='table-responsive mt-5'>
                        <table className='jobApplication-table'>
                            <tr>
                                <th>S No</th>
                                <th>Name</th>
                                <th>Email</th>
                                <th>Phone</th>
                                <th>Cause</th>
                                <th>Amount</th>
                                <th>Number of People</th>
                                <th>Payment Id</th>
                                <th>Status</th>
                                <th>Date</th>
                            </tr>

                            {loading ? (
                                <tr><td colspan='10'>Loading Applications...</td></tr>
                            ) : (
                                donationHistory.map((donation, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{donation.name}</td>
                                        <td>{donation.email}</td>
                                        <td>{donation.phone}</td>
                                        <td>{donation.cause}</td>
                                        <td>{donation.amount}</td>
                                        <td>{donation.numberOfPeople}</td>
                                        <td>{donation.paymentId}</td>
                                        <td>{donation.status}</td>
                                        <td>{formatDate(donation.donationDate)}</td>
                                    </tr>
                                ))
                            )}
                        </table>
                    </div>


                </div>
            </section>
        </>
    )
}

export default DonationHistory
